import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const closeMenu = () => setIsOpen(false);

  useEffect(() => {
    let lastY = 0;
    const handleScroll = () => {
      const navbar = document.querySelector('.navbar');
      if (!navbar) return;
      const y = window.scrollY;
      navbar.classList.toggle('scrolled', y > 40);
      navbar.classList.toggle('hidden', y > 80 && y > lastY);
      lastY = y;
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo" onClick={closeMenu}>
          Vi Tillsammans
        </Link>
        <div className="nav-right">
          <ul className={`nav-menu ${isOpen ? 'active' : ''}`}>
            <li><Link to="/home" onClick={closeMenu}>Hem</Link></li>
            <li><Link to="/mission" onClick={closeMenu}>Om oss</Link></li>
            <li><Link to="/gallery" onClick={closeMenu}>Galleri</Link></li>
            <li><Link to="/bidra" onClick={closeMenu}>Bidra</Link></li>
            <li className="mobile-only"><Link to="/anmalan" onClick={closeMenu}>Anmäl dig</Link></li>
          </ul>
          <Link to="/anmalan" className="nav-cta" onClick={closeMenu}>Anmäl dig</Link>
        </div>
        <div
          className="hamburger"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
